import { motion } from "framer-motion";
import { useI18n } from "../i18n";
import ListenButton from "./ListenButton";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ index, eyebrow, title, sub }) => {
  const { tr } = useI18n();
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <div className="flex items-baseline gap-4 border-b wp-rule pb-6">
          <span className="font-mono-wp text-xs text-[#718096]">{index}</span>
          <span className="wp-eyebrow">{tr(eyebrow)}</span>
          <span className="ml-auto"><ListenButton compact text={`${tr(title)}. ${sub ? tr(sub) : ""}`} /></span>
        </div>
        <h2 className="font-atlas text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#0E1726] mt-8 max-w-3xl leading-[1.05]">
          {tr(title)}
        </h2>
        {sub && <p className="text-[#4A5568] text-base md:text-lg mt-5 max-w-2xl leading-relaxed">{tr(sub)}</p>}
      </Reveal>
    </div>
  );
};
